import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TabsGreen } from '../../../../components/TabsGreen/TabsGreen';
import { InputDinamycPlaceholder, ButtonClose } from '@lk-gtcom/ecomlab-components';
import alarm_exclamation from './img/bx-alarm-exclamation.svg'
import select_multiple from './img/bx-select-multiple.svg'
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import { CreateBordFields } from './CreateBordFields/CreateBordFields';
import { StepItem } from '../../../../components/StepItem/StepItem';
import { SelectedColorsComponent } from '../../../../components/SelectedColorsComponent/SelectedColorsComponent';
import './ModalCreateBoard.scss'
import { TitlePage } from '../../../../components/TitlePage/TitlePage';
import { usePushNotifications } from '../../../../common/pushNotification';
import { DateBox } from '../../../../components/DateBox/DateBox';
import { periodWeek } from '../../../../common/constant';
import { ModalComponent } from '../../../../components/Modal/ModalComponent/ModalComponent';

const colors = [
    { color: '#e6d7c1', color_name: 'песочный' },
    { color: '#ffe5d0', color_name: 'кремово-оранжевый' },
    { color: '#ffc9a0', color_name: 'светло-оранжевый' },
    { color: '#f5e6aa', color_name: 'светло-желтый' },
    { color: '#fffacd', color_name: 'лимонный крем' },
    { color: '#e8f0c9', color_name: 'лимонный' },
    { color: '#d9e8d5', color_name: 'мятный' },
    { color: '#d5edc9', color_name: 'салатовый' },
    { color: '#c9f0e8', color_name: 'аквамарин' },
    { color: '#c9e8f0', color_name: 'небесный' },
    { color: '#d4e2f0', color_name: 'нежно-голубой' },
    { color: '#c9d9f0', color_name: 'голубой' },
    { color: '#e2c9f0', color_name: 'фиолетовый' },
    { color: '#d4c9f0', color_name: 'лиловый' },
    { color: '#f0c9e2', color_name: 'малиновый' },
    { color: '#ffa8a8', color_name: 'нежно-красный' },
    { color: '#e9ecef', color_name: 'ледяной серый' },
    { color: '#d4d8dc', color_name: 'пепельный' }
];

const ModalCreateBoard = ({
    setIsModal,
    taskId,
    fetchGetBord = () => { },
    setIsEdit,
    isEdit,
    currentBord,
    crm = false,
    ticket = false,
    task = false
}) => {

    const btns = [
        // { label: 'Обычная доска', value: 'board', icon: columns },
        ...(!task ? [{ label: 'Создание полей', value: 'fields', icon: select_multiple }]
            :
            [
                { label: 'Спринт доска', value: 'sprint-board', icon: alarm_exclamation },
                { label: 'Установить цвет', value: 'color' }
            ]),
    ];

    // Обработка ошибок
    const { addErrorPush, addSuccessPush } = usePushNotifications();

    const navigate = useNavigate();

    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const [currentTab, setCurrentTab] = useState(btns[0].value)

    const [funnelId, setFunnelId] = useState(isEdit ? currentBord?.id : null)
    const [name, setName] = useState(isEdit ? currentBord?.name : '')
    const [date, setDate] = useState(periodWeek())
    const selectedColor = colors.filter((color) => currentBord?.color == color?.color)
    const [currentColor, setCurrentColor] = useState(selectedColor?.[0])
    const [dateFrom, dateTo] = date

    const [initLoadDate, setInitLoaderDate] = useState(true);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const formateDate = (date) => {
        const timeZone = (new Date().getTimezoneOffset() / 60) * -3600000;
        const formate_date = new Date(
            new Date(date)?.getTime() + timeZone
        )?.toUTCString();
        return new Date(formate_date);
    };

    useEffect(() => {
        if (isEdit && currentBord) {
            setDate([new Date(currentBord?.start_time).getTime(), new Date(currentBord?.end_time).getTime()])
        }
    }, [isEdit]);

    // Создание пустой воронки
    const fetchCreateBord = () => {
        let url = `https://portals.ecomru.ru/api/crm/funnels/`
        if (ticket) {
            url = `https://portals.ecomru.ru/api/ticket/funnel/`
        }
        if (task) {
            url = `https://portals.ecomru.ru/api/v3/tasks/board/`;
        }

        const body = JSON.stringify({
            [task ? 'task_id' : 'project_id']: taskId
        });

        fetch(url, { body, method: isEdit ? 'PUT' : 'POST', headers })
            .then(res => {
                if (res.status === 409) {
                    addErrorPush('Лимиты по тарифу исчерпаны')
                    if (crm) {
                        navigate('/crm/project-for-crm/project')
                    }
                    if (task) {
                        navigate('/tasks/project-for-tasks')
                    }
                    if (ticket) {
                        navigate('/ticket/project-for-ticket/project')
                    }
                }
                if (!res?.ok) {
                    throw new Error('bad response')
                }
                return res.json()
            })
            .then((json) => {
                if (task) {
                    setTimeout(() => fetchGetBord(), 500)
                } else {
                    if (json) {
                        setFunnelId(json)
                    }
                }
            })
            .catch((err) => console.error(err));
    };

    // Добавление имени воронки
    const fetchAddNameBord = () => {
        if (funnelId) {
            let url = `https://portals.ecomru.ru/api/crm/funnels/name`
            if (ticket) {
                url = `https://portals.ecomru.ru/api/ticket/funnel/name`
            }
            if (task) {
                url = `https://portals.ecomru.ru/api/v3/tasks/board/name`
            }

            const body = JSON.stringify({
                [task ? 'board_id' : 'funnel_id']: funnelId,
                name: name
            });

            fetch(url, { body, method: 'PATCH', headers })
                .then((res) => res.json())
                .then((json) => fetchGetBord())
                .catch((err) => console.error(err));
        }
    };

    // Добавление даты начала
    const fetchAddStartDate = (start_time) => {
        if (funnelId) {
            let url = `https://portals.ecomru.ru/api/v3/tasks/board/start_time`

            const body = JSON.stringify({
                [task ? 'board_id' : 'funnel_id']: funnelId,
                start_time: formateDate(startDate).toISOString().split('T')?.[0]
            });

            fetch(url, { body, method: 'PATCH', headers })
                .then((res) => res.json())
                .then((json) => {
                    fetchGetBord()
                })
                .catch((err) => console.error(err));
        }
    };

    // Добавление даты начала
    const fetchAddEndDate = () => {
        if (funnelId) {
            let url = `https://portals.ecomru.ru/api/v3/tasks/board/end_time`

            const body = JSON.stringify({
                [task ? 'board_id' : 'funnel_id']: funnelId,
                end_time: formateDate(endDate).toISOString().split('T')?.[0]
            });

            fetch(url, { body, method: 'PATCH', headers })
                .then((res) => res.json())
                .then((json) => {
                    fetchGetBord()
                })
                .catch((err) => console.error(err));
        }
    };


    // Установка цвета
    const fetchSetColor = (color) => {
        if (funnelId) {
            let url = `https://portals.ecomru.ru/api/crm/funnels/color`
            if (ticket) {
                url = `https://portals.ecomru.ru/api/ticket/funnel/color`
            }
            if (task) {
                url = `https://portals.ecomru.ru/api/v3/tasks/board/color`
            }

            const body = JSON.stringify({
                [task ? 'board_id' : 'funnel_id']: funnelId,
                color: color?.color
            });

            fetch(url, { body, method: 'PATCH', headers })
                .then((res) => res.json())
                .then((json) => {
                    fetchGetBord()
                })
                .catch((err) => console.error(err));
        }
    };

    // Удаление воронки
    const deleteBord = async () => {
        let url = `https://portals.ecomru.ru/api/crm/funnels/${funnelId}`;
        if (ticket) {
            url = `https://portals.ecomru.ru/api/ticket/funnel/${funnelId}`
        }
        if (task) {
            url = `https://portals.ecomru.ru/api/v3/tasks/board/delete_task_board`
        }

        const body = JSON.stringify({
            task_board_id: funnelId
        })

        try {
            const res = await fetch(url, { method: 'DELETE', headers, body: task ? body : undefined });

            if (!res.ok) {
                const err = await res.json();
                throw new Error(JSON.stringify(err));
            }

            const json = await res.json();
            fetchGetBord();
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (!funnelId) {
            fetchCreateBord()
        }
    }, [funnelId]);

    useEffect(() => {
        if (!initLoadDate) {
            fetchAddStartDate();
            setInitLoaderDate(false);
        }
    }, [startDate]);

    useEffect(() => {
        if (!initLoadDate) {
            fetchAddEndDate();
            setInitLoaderDate(false);
        }
    }, [endDate]);



    return (
        <ModalComponent
            title={`${isEdit ? 'Редактирование' : 'Создание'} ${task ? ' доски' : ' воронки'}`}
            onClose={(e) => {
                if (!name) {
                    deleteBord()
                }
                setIsEdit(false)
                setIsModal(false)
            }}
            style={{
                maxWidth: '900px',
                height: 'auto',
                minHeight: '700px'
            }}
            childHeader={
                <InputDinamycPlaceholder
                    changeValue={name}
                    onChange={(e) => setName(e)}
                    placeholder={task ? 'Название доски' : 'Название воронки'}
                    size='s'
                    onBlur={fetchAddNameBord}
                    maxWidth='400px'
                />
            }
            child={
                <div className='modal-create-board'>
                    <TabsGreen
                        btns={btns}
                        currentBtn={currentTab}
                        setCurrentBtn={(e) => setCurrentTab(e)}
                        checkValue={true}
                    />

                    {currentTab == 'sprint-board' && <>
                        <TitlePage
                            medium
                            title='Выберите период для спринта'
                        />

                        <div className='modal-create-board__date-content'>
                            <DateBox
                                size='s'
                                onBlur={(e) => {
                                    if (initLoadDate) {
                                        setInitLoaderDate(false);
                                    }
                                }}
                                startDate={startDate}
                                description={'Дата начала'}
                                setStartDate={setStartDate}
                            />

                            <DateBox
                                size='s'
                                onBlur={(e) => {
                                    if (initLoadDate) {
                                        setInitLoaderDate(false);
                                    }
                                }}
                                startDate={endDate}
                                description={'Дата конца'}
                                setStartDate={setEndDate}
                            />
                        </div>
                    </>}

                    {/* Логика полей */}

                    {currentTab == 'fields' &&
                        <div className='modal-create-board__row'>
                            <CreateBordFields
                                funnelId={funnelId}
                                crm={crm}
                                task={task}
                                ticket={ticket}
                            />
                        </div>
                    }

                    {/* Установка цвета */}
                    {currentTab == 'color' && <div className='modal-create-board__row'>
                        <StepItem
                            title='Выберите цвет'
                        />

                        <SelectedColorsComponent
                            colors={colors}
                            currentColor={currentColor}
                            setCurrentColor={(e) => setCurrentColor(e)}
                            fetchSetColor={fetchSetColor}
                        />
                    </div>
                    }

                </div>
            }
        />
    )
}

export { ModalCreateBoard }